import { IconNames } from 'lib/settings/icons'
import Icon from '../Icon/Icon'

export interface StepsProps {
  /**
   * The steps to show
   */
  steps: string[]
  header?: string
}

export default function Steps({ header, steps = [] }: StepsProps) {
  return (
    <>
      {header && (
        <h2 className="text-center mb-8 mt-4 md:mt-2 text-[28px]">{header}</h2>
      )}
      <div className="flex justify-center items-center gap-x-6">
        {Array.from({ length: steps.length }).map((step, index) => {
          const stepNumber = index + 1
          const icon = `number-${stepNumber}-circle`
          const label = steps.length ? steps[index] : null
          const withDash = steps.length !== stepNumber

          return (
            <>
              <div key={index} className="leading-none flex gap-2 items-center">
                <div className="text-center">
                  <Icon
                    icon={icon as IconNames}
                    className="w-9 h-9 md:w-12 md:h-12 text-neutral-700"
                  />
                  {label && <div className="type-body-2 pt-2">{label}</div>}
                </div>
              </div>
              {withDash && (
                <div className="w-[72px] h-[2px] rounded-sm bg-current text-neutral-500"></div>
              )}
            </>
          )
        })}
      </div>
    </>
  )
}
